<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 footer-copyright">
            <p class="mb-0">Version 1.0.5 | Build 07062022</p>
            <p class="mb-0">Copyright 2022 ©infrabau GmbH</p>
          </div>
          <div class="col-md-6"></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import json from "../data/menu";
export default {
  name: "footerpage",
  data() {
    return {
      customizer: false,
      data: "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(json)),
      currentYear: 0
    };
  },
  async mounted() {
    this.currentYear = new Date().getFullYear();
  }
};
</script>
